import { ellipsis } from 'polished'
import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

interface TitleProps {
  isVideoOnly: boolean
  children: string
}

type StyledTitleProps = Pick<TitleProps, 'isVideoOnly'>

const StyledTitle = styled.div<StyledTitleProps>`
  ${({
    theme: {
      fonts: { goodOTNarrow: goodOTNarrowFontName },
      colors: {
        white,
        grey: { grey_100 },
      },
    },
    isVideoOnly,
  }) => css`
    font-family: ${goodOTNarrowFontName};
    font-weight: 900;
    line-height: 1.2;
    font-size: 18px;
    ${ellipsis('100%', 3)};
    color: ${isVideoOnly ? white : grey_100};

    > strong {
      color: ${isVideoOnly ? white : grey_100}
      font-weight: 900;
    }
    > p {
      color: ${isVideoOnly ? white : grey_100}
      margin: 0;
    }
  `}
`

const Title: FunctionComponent<TitleProps> = ({ isVideoOnly, children }) => (
  <StyledTitle
    isVideoOnly={isVideoOnly}
    dangerouslySetInnerHTML={{
      __html: children,
    }}
  />
)

export default Title
